var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "both-pd-box1" }, [
      _c(
        "div",
        {
          staticStyle: {
            background: "#fff",
            padding: "10px 30px",
            "border-radius": "20px",
          },
        },
        [
          _c("h3", [_vm._v("自定义邀请码管理")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "修改邀请码金额", prop: "money" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "800px" },
                          attrs: { placeholder: "请输入", clearable: "" },
                          model: {
                            value: _vm.form.money,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "money",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.money",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("元")])],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { color: "#aaaaaa" } }, [
                        _vm._v("输入用户修改邀请码需要的费用"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "免费修改功能", prop: "radio" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.radio,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "radio", $$v)
                            },
                            expression: "form.radio",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("打开"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { color: "#aaaaaa" } }, [
                        _vm._v(
                          "开启后满足等级要求的用户会获得1次免费修改邀请码的机会"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.radio
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "免费修改等级", prop: "level" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "800px" },
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.form.level,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "level", $$v)
                                },
                                expression: "form.level",
                              },
                            },
                            _vm._l(_vm.options, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.name, value: item.grade },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticStyle: { color: "#aaaaaa" } }, [
                            _vm._v(
                              "选择特定等级后，低于当前等级的用户会提示去升级，高于当前等级的会赠送1次修改邀请码的机会"
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v("\n              保存\n            ")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.handleReset } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }